module.exports = __webpack_public_path__ + "img/deodorizer_wash.18b07d04.svg";